<template>
    <div>
        
        <div class="row justify-content-center">
            <div class="col col-12 col-md-12 col-lg-8">

                <!-- Start da Marcação -->

                <div class="row d-flex justify-content-center" v-if="!fluxo">

                    <div class="col col-12 col-md-6">
                        <a href="#" @click.prevent="startFluxo(2)" class="card border-0 card-templates dashcard card-link az-anime-surgir">
                            <div class="card-body d-flex align-items-center flex-column text-center text-white atalho" style="--height: 400px;"
                                :class="'bg-success'">
                                <i class="fas fa-user-check fa-4x"></i>
                                <div class="display-4 atalho-titulo mt-2">
                                    <small>Paciente</small>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="col col-12 col-md-6">
                        <a href="#" @click.prevent="startFluxo(1)" class="card border-0 card-templates dashcard card-link az-anime-surgir">
                            <div class="card-body d-flex align-items-center flex-column text-center text-white atalho" style="--height: 400px;"
                                :class="'bg-danger'">
                                <i class="fas fa-user-check fa-4x"></i>
                                <div class="display-4 atalho-titulo mt-2">
                                    <small class="text-nowrap text-truncate">Primeira Vez</small>
                                </div>
                            </div>
                        </a>
                    </div>

                </div>

                <div v-if="fluxo"> 

                    <div class="row w3-animate-opacity">
                        <div class="col col-12 mb-3 d-flex flex-column">
                            <button type="button" class="btn btn-outline-secondary" @click="reiniciar ()"> 
                                Voltar
                            </button>
                        </div>
                    </div>

                    <template v-if="!dados.procedimento || !dados.medico">
                    
                        <!-- Seleção da Unidade -->

                        <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="fluxo && this.$store.state.unidade.unidade_operacaos.length > 1">

                            <div class="col col-12">
                                <az-input
                                    type="select"
                                    :optionsList="lista_unidades"
                                    icon="fa fa-building fa-fw"
                                    placeholder="Selecione a Unidades..."
                                    v-model="dados.unidade_operacao" />

                                <!--

                                <div class="input-group mb-1">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">
                                            <i class="fa fa-building fa-fw" aria-hidden="true"></i>
                                        </span>
                                    </div>

                                    <select class="form form-control" v-model="dados.unidade_operacao">
                                        <option value="">Selecione a unidade...</option>
                                        <option v-for="(und, iux) in this.$store.state.unidade.unidade_operacaos" :value="und" :key="iux">{{ und.search }}</option>
                                    </select>
                                </div>
                                -->
                            </div>

                        </div>

                        <template v-if="this.$store.state.unidade.unidade_operacaos.length <= 1 || dados.unidade_operacao">

                            <!-- Seleção do Paciente-->

                            <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="fluxo == 2">

                                <div class="col col-12">

                                    <az-input 
                                        placeholder="Paciente"
                                        icon="fas fa-user"
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="pacientes.index"
                                        optionsDisplay="search"
                                        ref="info_paciente"
                                        v-model="dados.paciente" 
                                        @onEnter="focusOn('info_plano')"
                                        @input="selecionarPaciente()" />

                                </div>

                            </div>

                            <!-- Seleção da Operadora / Plano -->

                            <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="fluxo && ( fluxo == 1 || dados.paciente )">

                                <div class="col col-12">

                                    <AzInput placeholder="Operadora/Plano"
                                            icon="far fa-credit-card"
                                            type="autocomplete" 
                                            optionsMode="aql"
                                            service="planos.index"
                                            :optionsSync="false"
                                            v-model="dados.plano"
                                            ref="info_plano"
                                            @input="selecionarPlano(dados.plano)"
                                            @onEnter="focusOn('info_procedimento')" />

                                </div>

                                <div class="col col-12" v-if="this.$store.state.options.marcacoesStats && !dados.plano">

                                    <ul class="list-group">
                                        <button type="button" class="list-group-item list-group-item-action"
                                            v-for="(item, id) in this.$store.state.options.marcacoesStats.planos" :key="id"
                                            @click="selecionarPlano (item.plano)">
                                            {{ item.plano.search }}
                                        </button>
                                    </ul>

                                </div>

                            </div>

                            <!-- Seleção do Procedimento -->

                            <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="fluxo && dados.plano">

                                <div class="col col-12">

                                    <div v-if="!dados.procedimento && adicoes && adicoes.length" class="mb-2">
                                        <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click="selecionarAdicao(adicao)" v-for="(adicao, iax) in adicoes" :key="iax">
                                            {{ adicao.st_titulo }}
                                        </button>
                                    </div>

                                    <AzInput placeholder="Procedimento"
                                            icon="fas fa-play"
                                            type="autocomplete" 
                                            optionsMode="aql"
                                            :optionsName="$store.state.user.proc_oper ? 'procedimentos.agenda.op.' + dados.plano.id_operadora : 'procedimentos.agenda'"
                                            :optionsParm="$store.state.user.proc_oper 
                                                ? { 
                                                    id_operadora: dados.plano.id_operadora,
                                                    id_unidade_operacao: ( dados && dados.unidade_operacao ) ? dados.unidade_operacao.id_unidade_operacao : null 
                                                } 
                                                : {
                                                    id_unidade_operacao: ( dados && dados.unidade_operacao ) ? dados.unidade_operacao.id_unidade_operacao : null 
                                                }"
                                            :optionsSync="false"
                                            v-model="dados.procedimento"
                                            ref="info_procedimento"
                                            @input="selecionarProcedimento (dados.procedimento)" 
                                            @onEnter="enterNoProcedimento ()" />

                                </div>

                                <div class="col col-12" v-if="procStats && !dados.procedimento">

                                    <ul class="list-group">
                                        <button type="button" class="list-group-item list-group-item-action list-group-item-light"
                                            v-for="(item, id) in procStats" :key="id"
                                            @click="selecionarProcedimento (item.procedimento)">
                                            {{ item.procedimento.search }}
                                        </button>
                                    </ul>

                                </div>

                            </div>

                            <!-- Selecionar Médico -->

                            <div class="row d-flex justify-content-center mb-3 w3-animate-opacity" v-if="fluxo && dados.procedimento">

                                <div class="col col-12">

                                    <!-- optionsMode="aql" service="medicos.index" -->
                                            
                                    <AzInput placeholder="Profissional"
                                            icon="fas fa-briefcase-medical"
                                            type="autocomplete" 
                                            :optionsList="listaMedicos"
                                            optionsData="" 
                                            optionsDisplay="st_nome_exibicao"
                                            :optionsSync="false"
                                            v-model="dados.medico"
                                            ref="info_medico"
                                            @input="selecionarMedico (dados.medico)"
                                            @onEnter="enterNoMedico ()" />

                                </div>

                                <div class="col col-12" v-if="pacienteMedicoStats && !dados.medico">

                                    <ul class="list-group">
                                        <button type="button" class="list-group-item list-group-item-action list-group-item-light"
                                            v-for="(item, id) in pacienteMedicoStats" :key="id"
                                            @click="selecionarMedico (item.medico)">
                                            {{ item.medico.st_nome_exibicao }}
                                        </button>
                                    </ul>

                                </div>

                                <div class="col col-12" v-else-if="!dados.medico && listaMedicos && listaMedicos.length > 0 && listaMedicos.length <= 5">

                                    <ul class="list-group">
                                        <button type="button" class="list-group-item list-group-item-action list-group-item-light"
                                            v-for="(item, id) in listaMedicos" :key="id"
                                            @click="selecionarMedico (item)">
                                            {{ item.st_nome_exibicao }}
                                        </button>
                                    </ul>

                                </div>

                            </div>

                        </template>

                    </template>

                    <!-- Informações do Paciente -->

                    <div v-if="dados.procedimento && dados.medico">

                        <cadastro-temporario v-model="cadastro_temporario" v-if="fluxo == 1 && !dados.paciente" :validate="validate" @selecionar="identificar_paciente"/>

                        <div v-if="dados.tem_apoiado" class="form-row mt-3">
                            <div class="col col-12">
                                <az-input
                                    placeholder="Apoiado..."
                                    icon="fa-solid fa-house-signal fa-fw"
                                    sizing="sm"
                                    type="autocomplete"
                                    service="apoiados.index"
                                    optionsMode="aql"
                                    optionsName="apoiados.index"
                                    optionsParm2="{ id_atendimento: dados.atendimento.id_atendimento }"
                                    v-model="dados.apoiado" />
                            </div>
                        </div>

                        <az-sub-title title="Justificativa" />

                        <div class="row">
                            <div class="col col-12 col-md-4">
                                <az-input label="CID Principal" 
                                    sizing="sm"
                                    type="autocomplete" 
                                    optionsMode="aql" 
                                    service="cids.index" 
                                    optionsData="id_cid" 
                                    optionsDisplay="search"
                                    v-model="dados.id_cid_principal" 
                                    :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input label="CID Secundário" 
                                    sizing="sm"
                                    type="autocomplete" 
                                    optionsMode="aql" 
                                    service="cids.index" 
                                    optionsData="id_cid" 
                                    optionsDisplay="search"
                                    v-model="dados.id_cid_secundario" 
                                    :validate="validate" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input label="CID Causas Associadas" 
                                    sizing="sm"
                                    type="autocomplete" 
                                    optionsMode="aql" 
                                    service="cids.index" 
                                    optionsData="id_cid" 
                                    optionsDisplay="search"
                                    v-model="dados.id_cid_causa_assoc" 
                                    :validate="validate"  />
                            </div>
                        </div>

                        <div class="row mb-2">
                            <div class="col col-12">
                                <az-input
                                    label="Justificativa"
                                    type="textarea"
                                    rows="3"
                                    v-model="dados.st_observacoes" />
                            </div>
                        </div>

                        <div v-if="dados.js_secundarios && dados.js_secundarios.length">
                            <span class="badge badge-secondary" title="Quantidade">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                {{ dados.js_secundarios.length }}
                            </span>
                        </div>

                        <template v-if="dados.js_secundarios">
                            <div v-for="(proced, ipx) in dados.js_secundarios" :key="ipx">
                                <az-input
                                    sizing="sm"
                                    :edicao="false"
                                    v-model="proced.search">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerElemento(dados.js_secundarios, ipx)">
                                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>     
                        </template>
                        <az-input
                            placeholder="Adicionar procedimento..."
                            sizing="sm"
                            icon="fas fa-plus fa-fw"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="procedimentos.index" 
                            :optionsParm="{
                                agenda: true, 
                                agenda_add: true, 
                                ativos: true, 
                                id_medico: dados.medico ? dados.medico.id_pessoa : null, 
                                id_operadora: dados.plano.id_operadora,
                                id_unidade_operacao: ( dados && dados.unidade_operacao ) ? dados.unidade_operacao.id_unidade_operacao : null 
                            }"
                            :procsigla="true"
                            v-model="novoProcedimento"
                            ref="info_procedimento"
                            @selecionado="incluirProcedimento()" />

                        <div class="row d-flex justify-content-center mt-3 mb-3">

                            <div class="col col-12 d-flex flex-column">
                                <az-submit @click="concluir()">
                                    Concluir
                                </az-submit>
                            </div>

                        </div>

                    </div>

                    <div v-if="historicoMarcacoes">

                        <!-- Histórico v-else-if="dados.paciente"  -->
                        <historico-marcacoes
                            v-if="dados.paciente"
                            ref="historico"
                            :historico="historicoMarcacoes" 
                            :autorizacao="historicoAutorizacao"
                            :poderevisar="true"
                            :tela_aut="true"
                            @agendar="selecionarDaRequisicao" />

                    </div>

                </div>

            </div>

            <div class="col col-12 col-md-4" v-if="fluxo">
                
                <procedimentos-solicitados
                    v-model="procedimentos"
                    :cores="cores"
                    :removeOnUnSelect="true" />
                
            </div>

        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import ProcedimentosSolicitados from '../callcenter/ProcedimentosSolicitados.vue';
import CadastroTemporario from '../callcenter/CadastroTemporario.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import HistoricoMarcacoes from '../callcenter/HistoricoMarcacoes.vue';

export default {
    data() { 
        return { 
            dados: {
                unidade_operacao: "", 
            },
            fluxo: null,
            pacienteProcStats: null, 
            pacienteMedicoStats: null,
            listaMedicos: [], 
            procedimentos: [],
            cores: [ 'success', 'info', 'warning', 'secondary', 'danger', 'primary' ],
            cadastro_temporario: {
                st_nome: "",
                dt_nascimento: "", 
                st_telefone: "",
                st_celular: "", 
            },
            validate: false, 
            novoProcedimento: "", 
            canceltoken_paciente: null, 
            buscando_paciente: null,
            historicoMarcacoes: null, 
            adicoes: [], 
        }
    },

    components: { 
        AzInput,
        AzSubmit, 
        AzSubTitle, 
        CadastroTemporario,
        ProcedimentosSolicitados,
        HistoricoMarcacoes, 
    },

    computed: { 
        lista_unidades: function () {
            // this.$store.state.unidade.unidade_operacaos
            return _.orderBy(
                this.$util.unidades_com_tags(false, true).filter(item => !item.fl_unidade_adm),
                'st_nome'
            );
        },

        procStats: function () { 

            return this.pacienteProcStats && this.pacienteProcStats.procedimentos && 
                    this.pacienteProcStats.procedimentos.length ? 
                    this.pacienteProcStats.procedimentos : 
                    ( this.$store.state.options.marcacoesStats ?
                        this.$store.state.options.marcacoesStats.procedimentos : null );

        }
    },

    methods: { 
        selecionarAdicao (adicao) { 
            this.$util.load(this, { 
                service: 'procedimentos',
                func: 'show',
                parms: { 
                    id: adicao.id_procedimento,
                },
                loadTo: res => { 
                    this.dados.procedimento = res;
                    this.selecionarProcedimento(this.dados.procedimento);

                    this.$util.load(this, { 
                        service: 'medicos',
                        func: 'show',
                        parms: { 
                            id: adicao.id_medico,
                        },
                        loadTo: res => { 
                            this.dados.medico = res;
                            this.selecionarMedico (this.dados.medico);
                        }
                    })
                }
            });
        },
        
        selecionarDaRequisicao (item) { 
            if ( this.dados.procedimento && this.dados.medico ) { 
                this.novoProcedimento = item;
                this.incluirProcedimento();
                return;
            }
            
            this.selecionarProcedimento(item);
        },

        selecionarPaciente (existente = false) { 

            this.$nextTick(() => {

                if ( this.dados.paciente ) { 

                    if ( this.buscando_paciente ) { 
                        if ( this.buscando_paciente == this.dados.paciente.id_pessoa ) 
                            return;
                        else if ( this.canceltoken_paciente )
                            this.canceltoken_paciente.cancel('#BC#');
                    }

                    this.buscando_paciente = this.dados.paciente.id_pessoa;

                    if ( !existente ) { 
                        this.focusOn ('info_plano');

                        if ( _.get(this.dados, 'paciente.paciente_unidade.plano.id_operadora') == 1 
                            && _.get(this.dados, 'paciente.paciente_unidade.plano.id_plano') == 1 
                            && _.get(this.dados, 'paciente.st_id_externo') ) { 

                            this.dados.plano = null;

                        } else { 

                            this.dados.plano = this.dados.paciente.paciente_unidade.plano;

                        }
                    }

                    let query = { q: [ 
                        { 
                            name: 'marcacoes.stats',
                            id: 'stats_pac',
                            parms: { 
                                id_paciente: this.dados.paciente.id_pessoa,
                            }
                        }
                    ]};

                    this.canceltoken_paciente = this.axios.CancelToken.source();

                    this.axios.post('/aql?a=marcacoes.stats&p=' + this.dados.paciente.id_pessoa, query, {
                            cancelToken: this.canceltoken_paciente.token
                        })
                        .then(res => { 
                            if ( res.data.stats_pac.status == 200 ) {
                                this.historicoMarcacoes = res.data.stats_pac.data.marcacoes;
                                this.historicoAutorizacao = res.data.stats_pac.data.autorizacao;

                                /*
                                this.pacienteProcStats = res.data.stats_pac.data;
                                this.historicoMarcacoes = res.data.stats_pac.data.marcacoes;
                                this.historicoLegado = res.data.stats_pac.data.legado;
                                
                                if ( this.$refs.historico ) { 
                                    this.$nextTick(() => { 
                                        this.$refs.historico.verificar_aba();
                                    });
                                }
                                */
                            }
                        })
                        .finally(() => { 
                            this.buscando_paciente = null;
                            this.canceltoken_paciente = null;
                        });
                }

            });

        },

        removerElemento (lista, index) { 
            lista.splice(index, 1);
        },

        incluirProcedimento() { 
            if ( Array.isArray(this.novoProcedimento) ) { 
                let lista = _.cloneDeep(this.novoProcedimento);

                lista.forEach(proc => { 
                    this.novoProcedimento = proc;
                    this.incluirProcedimento();
                });
                return;
            }

            if ( this.novoProcedimento && this.dados ) { 
                if ( !this.dados.js_secundarios )
                    this.dados.js_secundarios = [];

                this.dados.js_secundarios.push({ 
                    in_quantidade: 1, 
                    id_procedimento: this.novoProcedimento.id_procedimento,
                    st_procedimento: this.novoProcedimento.st_procedimento, 
                    search: this.novoProcedimento.search,
                    in_status: 0, 
                });
            }

            this.$nextTick(() => {
                this.novoProcedimento = "";
            });
        },

        concluir() { 

            if ( this.fluxo == 1 )
                this.dados.cadastro_temporario = this.cadastro_temporario;

            this.$util.atualizar(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'store',
                dados: this.dados,
                modal: 'novaSolicitacaoModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        reiniciar() { 
            this.validate = false;
            this.fluxo = null;
            this.historicoMarcacoes = null; 
            this.dados = {
                unidade_operacao: "", 
                js_secundarios: [], 
                in_status: 0, 
                fl_avulso: true, 
                tem_apoiado: false, 
            };
            this.cadastro_temporario = {
                st_nome: "",
                dt_nascimento: "", 
                st_telefone: "",
                st_celular: "", 
            };

            if ( this.$util.unidade_operacao() ) { 
                this.dados.unidade_operacao = this.$util.unidade_operacao();
            }
        },

        startFluxo(fluxo) { 
            this.historicoMarcacoes = null; 
            this.dados.unidade_operacao = "";
            this.fluxo = fluxo;

            if ( this.$util.unidade_operacao() ) { 
                this.dados.unidade_operacao = this.$util.unidade_operacao();
            }
        },

        selecionarPlano (plano) { 

            this.dados.plano = plano;

            this.$nextTick(() => {
                this.focusOn('info_procedimento');
            });

            let recep = this.$util.recepcao();

            this.adicoes = recep ? recep.adicoes.filter(item => !item.st_tipo || item.st_tipo == 'A')
                .filter(item => !item.fl_preferencial) : [];

        },

        selecionarProcedimento (procedimento) { 

            this.dados.procedimento = procedimento;
            this.listaMedicos = [];

            if ( this.data ) { 
                this.dados.repetir = false;
                this.dados.repeticao = { 
                    base: this.data, 
                    hora: this.hora 
                };
            }

            this.$nextTick(() => {
                this.focusOn('info_medico');
            });

            if ( procedimento ) { 

                let query = { q: [ 
                    { 
                        name: 'marcacoes.stats',
                        id: 'stats_proc',
                        parms: { 
                            id_plano: this.dados.plano.id_plano,
                            id_procedimento: procedimento.id_procedimento,
                            solicaut: true,
                        }
                    },
                    { 
                        name: 'apoiados.index',
                        id: 'apoiados',
                        parms: { 
                            size: 1 
                        }
                    }
                ]};

                this.axios.post('/aql', query)
                    .then(res => { 
                        if ( res.data.stats_proc.status == 200 ) {
                            this.listaMedicos = res.data.stats_proc.data.medicos;
                        }

                        if ( res.data.apoiados.status == 200 ) {
                            if ( res.data.apoiados.data && res.data.apoiados.data.length ) { 
                                this.dados.tem_apoiado = true;
                            }
                        }
                    });

            }

            if ( this.dados.paciente ) { 

                let query = { q: [ 
                    { 
                        name: 'marcacoes.stats',
                        id: 'stats_proc_pac',
                        parms: { 
                            id_paciente: this.dados.paciente.id_pessoa,
                            id_procedimento: procedimento ? procedimento.id_procedimento : null,
                        }
                    }
                ]};

                this.axios.post('/aql', query)
                    .then(res => { 
                        if ( res.data.stats_proc_pac.status == 200 ) {
                            this.pacienteMedicoStats = res.data.stats_proc_pac.data.medicos;
                        }
                    });

            } 
            
        },

        selecionarMedico (medico) { 

            this.dados.medico = medico;
            
            this.$nextTick(() => {
                this.focusOn('adicionar');
            });

            if ( medico && this.data && !this.hora ) { 

                if ( $('#campo-cadastro-temporario select').length ) { 
                    $('#campo-cadastro-temporario select')[0].focus(); 
                }

                this.espontaneaHora = null;
                this.buscando = true;

                let query = { q: [ 
                    { 
                        name: 'medicos.horarios',
                        id: 'horarios',
                        parms: { 
                            id_medico: medico.id_pessoa,
                            id_procedimento: this.dados.procedimento.id_procedimento,
                            data: this.data,
                            id_unidade_operacao: this.id_unidade_operacao, 
                        }
                    }
                ]};

                this.axios.post('/aql', query)
                    .then(res => { 
                        if ( res.data.horarios.status == 200 ) {
                            this.faixaHorarios = res.data.horarios.data;
                        }
                    })
                    .finally(() => { 
                        this.buscando = false;
                    });

            }

        },

        enterNoProcedimento () { 

            if ( !this.dados.procedimento && this.procedimentos.length ) { 
                this.buscarHorarios ();
            }

        },

        enterNoMedico () { 

            if ( this.dados.procedimento ) { 
                this.adicionarProcedimento () 
            }

        },

        adicionarProcedimento () { 

            let procedimento = _.cloneDeep (this.dados);

            procedimento.selected = true;
            
            this.procedimentos = [];
            this.procedimentos.push(procedimento);

        },

        removerProcedimento (index) { 

            this.procedimentos.splice(index, 1);

        },


        focusOn (item) { 

            if ( this.$refs[item] ) { 
                this.$refs[item].$refs.input.focus ();
            } 

        },

        identificar_paciente (id_paciente) { 

            this.$store.commit("loading", true);

            this.$util.loadItem(this, { 
                service: "pacientes",
                func: "show",
                parms: { 
                    id: id_paciente,
                }
            })
            .then(res => { 
                this.dados.paciente = res;

                if ( this.data ) { 
                    this.selecionarPaciente(true);
                    //this.$refs.instruc_conf.$forceUpdate();
                }
            })
            .finally(() => { 
                this.$store.commit("loading", false);
            });

        },

    }
}
</script>

<style scoped>
.modal-dialog2 {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

.atalho { 
    opacity: 0.95;
}

.atalho:hover {
	opacity: 1;
}

.atalho:hover i { 
    -webkit-transition: opacity 0.2s ease-in;
    -moz-transition: opacity 0.2s ease-in;
    -o-transition: opacity 0.2s ease-in;
    transition: opacity 0.2s ease-in;
    opacity: 0;
}

.atalho:hover div {
	-webkit-transform: translate3d(0,-30px,0);
	transform: translate3d(0,-30px,0);
}

.atalho:hover div {
	-webkit-transition-delay: 0.05s;
	transition-delay: 0.05s;
	-webkit-transition-duration: 0.35s;
	transition-duration: 0.35s;
}

.atalho i,
.atalho div {
	-webkit-transition: -webkit-transform 0.35s;
	transition: transform 0.35s;
}

.az-anime-surgir {
  animation: az-surgir 1s;
}

@keyframes az-surgir {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1) ease-in-out;
  }
}

.az-anime-slide { 
    left: -10px;
    animation: az-slide 0.5s forwards;
    animation-delay: 2s;
}

@keyframes az-slide { 
    100% { left: 0; }
}
</style>